// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sixBody[data-v-78f9879e] {\n  padding: 10px 20px;\n  height: calc(100% - 46px);\n}", ""]);
// Exports
module.exports = exports;
